//@ts-ignore
//@ts-nocheck
import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { API } from "aws-amplify";
import DateTimePicker from "react-datetime-picker";

import {
  calcDaysPassed,
  validatorField,
} from "../../Utils/validators";
import { getQuizIndexParent } from "../../Utils/utils";
import ErrorCustom from "../../Components/errorCustom";
import {
  addHealthStatement,
  modalSteps,
  stepPosition,
} from "../../Store/simulate/actions";
import useBeforeFirstRender from "../../customHook/useBeforFirstRender";
import BreadCrumbs from "../BreadCrumbs";
import ModalSteps from "./FormElements/ModalSteps";
import Button from "../../Components/FormElements/Button";
import FormTitle from "../../Components/FormElements/FormTitle";
import NavCase from "../../Components/FormElements/NavCase";
import Footer from "../../Components/Footer";
import NavResponsive from "../../Components/FormElements/NavResponsive";


import { Questions } from "../../interfaces/healtStatement";

import IconBack from "../../Resources/svg/Icons/IconBack";
import CalendarIcon from "../../Resources/svg/date-picker.svg";

export const HealthStatement = () => {
  const [loadingClick, setLoadingClick] = useState<boolean>(false);
  const dataStore = useSelector(
    (state: any) => state.simulate.policy.healthStatement
  );
  const {datosCliente, datosSimulacion, idSimulacion} = useSelector((state: any) => state.simulate.policy.client);
  const dataQuiz = useSelector((state: any) => state.quiz.quizDPS);
  const [enableButton, setEnableButton] = useState<any>(true);
  const client = datosCliente;
  const simulation = datosSimulacion;
  const dispatch = useDispatch();
  const {
    handleSubmit,
    register,
    errors,
    watch,
    formState: { isValid },
  } = useForm({ mode: "onChange" });
  const history = useHistory();
  const [questions, setQuestions] = useState<any>([]);

  useEffect(() => {
    if (dataStore.length > 0) {
      setQuestions(dataStore);
    } else {
      const dataQuestions = dataQuiz.filter((item: any) => item.sk !== "DPS#AS");
      dataQuestions.map((item: any, i: any) => {
        const index = getQuizIndexParent(dataQuiz, i);
        item.value = null;
        item.parent = index;
        item.show = true;
      });
      setQuestions(dataQuestions);
    }
    dispatch(stepPosition(3));

    window.digitalData.push({
      virtual: {
        name: "aiv:inversion-global:cotizar:declaracion-salud",
      },
      event: "trackVirtual",
    });
  }, []);

  const setValueQuestions = (index: number, value: any) => {
    let clon = [...questions];
    clon[index].value = value;
    if (typeof value === "boolean") {
      clon.forEach((item) => {
        if (item.parent === index) {
          item.value = null;
          item.show = value;
        }
      });
    }
    setQuestions(clon);
  };

  const checkActive = (index: number) => {
    let parent = questions[index].entityData.split(".");
    parent = parent.slice(0, -1);
    parent = parent.join(".");
    const parentItem = questions.find((item: Questions) => item.entityData === parent);
    if (!parentItem) {
      return "hidden";
    }
    return !parentItem.value ? "hidden" : "show";
  };
  const [selectDate, setselectDate] = useState<any>({});
  const [errorDate, setErrorDate] = useState<any>(null);

  const handleDateChange = (date: any, i :any, name: any) => {

    const dateCalc = calcDaysPassed(date)
    
    if (dateCalc >= 0) {
      setErrorDate( "La fecha no debe ser mayor al día de hoy");
      setselectDate({
        ...selectDate,
        [name]: date,
      });
    }else {
      const transformDate = new Intl.DateTimeFormat("es-PE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(date);
      setselectDate({
        ...selectDate,
        [name]: date,
      });
      setErrorDate(null);
      setValueQuestions(i, transformDate);
    }
    
  };
  const handleChange = (e: any, index: any) => {
    const { value } = e.target;
    setValueQuestions(index, value);
  };

  const { a, b, c, d } = watch();

  const onSubmit = (data: any) => {
    if (errorDate !== null) return;

    setLoadingClick(true);
    const dps = simulation.dpsAfirmativa;
    
    const newDate: any = {};
    Object.keys(selectDate).forEach((name) => {
      const transformDate = new Intl.DateTimeFormat("es-PE", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
      }).format(selectDate[name]);
      newDate[name] = transformDate;
    });
    const newObject = [{
      ...questions,
      ...newDate,
      // [nameHas]: transformDate,
    }];
   
    setTimeout(async () => {
      setEnableButton(false);
      dispatch(addHealthStatement(questions));

      const dataRadio = a == "SI" || b == "SI" || c == "SI" || d == "SI";
      const request = {
        body: {
          idSimulacion: idSimulacion,
          estado: "cancel",
        },
      };
      const pathDeclaracion = "/cotizaciones/declaracion-jurada";
      if (dps === false) {
        dispatch(stepPosition(4));
        if (dataRadio === false) {
          history.push("/cotizaciones/beneficiarios");
        }
        if (dataRadio === true) {
          await updateStatusQuote(request);
          history.push(pathDeclaracion);
        }
      }
      if (dps === true) {
        dispatch(stepPosition(4));
        if (dataRadio === true) {
          history.push("/cotizaciones/beneficiarios");
        }
        if (dataRadio === false) {
          await updateStatusQuote(request);
          history.push(pathDeclaracion);
        }
      }
      setLoadingClick(false);
    }, 500);
  };

  const updateStatusQuote = async (request: any) => {
    const response = await API.post("api-rentas", "/save-quote", request);
    if (response.status) {
    }
  };

  useBeforeFirstRender(client);

  const handleOpenModal = () => {
    dispatch(modalSteps(true));
  };

  return (
    <>
      <div className="wrap">
        <NavResponsive position={3} title="Declaración de salud" />
        <div className="content-box d-flex">
          <div className="nav-case">
            <BreadCrumbs
              rutas={[{ link: "Simulaciones" }, { link: "Cotización" }]}
            />
            <div className="nav-case__routing">
              <IconBack className="nav-case__back" onClick={handleOpenModal} />
              <div className="nav-case__title">Declaración de salud</div>
              <NavCase />
            </div>
          </div>
          <div className="form-register">
            <FormTitle
              title="Completa la declaración de salud del contratante"
              parrafo="El contratante es la persona que es titular de la póliza y asegurado a la vez."
            />
            <form onSubmit={handleSubmit(onSubmit)}>
              {questions.map((question: any, index: any) => (
                <div key={index}>
                  <>
                    {questions[index].parent == null && (
                      <div className="healthCard">
                        {question.questionType === "boolean" && (
                          <>
                            <p>
                              {question.metadata.numeration
                                ? `${question.metadata.numeration}) `
                                : ``}
                              {question.title}
                            </p>
                            <div
                              className={
                                "clientForm__form__item" +
                                (errors[question.sk] ? " is-error" : "")
                              }
                            >
                              <p>
                                <label>
                                  <input
                                    className="with-gap"
                                    id={question.sk}
                                    name={question.metadata.numeration}
                                    type="radio"
                                    value="SI"
                                    ref={register({ validate: validatorField })}
                                    defaultChecked={
                                      question.value === true
                                    }
                                    onClick={() =>
                                      setValueQuestions(index, true)
                                    }
                                  />
                                  <span>Sí</span>
                                </label>
                              </p>
                              <p>
                                <label>
                                  <input
                                    className="with-gap"
                                    id={question.sk}
                                    name={question.metadata.numeration}
                                    value="NO"
                                    type="radio"
                                    ref={register({ validate: validatorField })}
                                    defaultChecked={
                                      question.value === false
                                    }
                                    onClick={() =>
                                      setValueQuestions(index, false)
                                    }
                                  />
                                  <span>No</span>
                                </label>
                              </p>
                            </div>
                            <ErrorCustom errors={errors} name={question.sk} />
                          </>
                        )}

                        <div
                          className={`clientForm__container ${
                            questions[index].value ? "" : "hidden"
                          }`}
                        >
                          <div className="clientForm__title">
                            Detalla esta información
                          </div>
                          <div className="display-grid">
                            {questions.map(
                              (q: any, i: any) =>
                                q.parent === index && (
                                  <>
                                    {q.questionType === "input" && q.show && (
                                      <div
                                        className={`input-field noTitle child area--${
                                          (i % 5) % 4
                                        } ${checkActive(index)}`}
                                        key={index}
                                      >
                                        <input
                                          className={
                                            errors[q.sk] ? "is-error" : ""
                                          }
                                          id={q.sk}
                                          name={q.sk}
                                          type="text"
                                          autoComplete="off"
                                          ref={register({
                                            validate: validatorField,
                                          })}
                                          defaultValue={q.value || ""}
                                          onChange={(e) => handleChange(e, i)}
                                          maxLength={
                                            q.metadata.maxLength || "100"
                                          }
                                        />
                                        <label
                                          className={q.value ? "active" : ""}
                                          htmlFor={q.sk}
                                        >
                                          {q.metadata.placeholder}
                                        </label>
                                        <ErrorCustom
                                          errors={errors}
                                          name={q.sk}
                                        />
                                      </div>
                                    )}

                                    {q.questionType === "date" && q.show && (
                                      <div
                                        className={`input-field area--${
                                          (i % 5) % 4
                                        } child ${checkActive(index)}`}
                                      >
                              
                                        <div
                                          className={`datapicker-single ${
                                            errorDate && "is-error"
                                          }`}
                                        >
                                          <div className="datapicker-single__body">
                                            <div>
                                              <label className="datapicker__label">
                                                {q.metadata.placeholder}
                                              </label>
                                            </div>
                                            <DateTimePicker
                                              name={q.sk}
                                              value={selectDate[q.sk]}
                                              onChange={(e) =>
                                                handleDateChange(e, i, q.sk)
                                              }
                                              format="dd-MM-yy"
                                              dayPlaceholder="dd"
                                              monthPlaceholder="mm"
                                              yearPlaceholder="yy"
                                              calendarIcon={
                                                <img src={CalendarIcon} />
                                              }
                                              clearIcon={null}
                                            />
                                            
                                          </div>
                                        </div>

                                        {/* <input
                                          className={
                                            errors[q.sk] ? "is-error" : ""
                                          }
                                          id={q.sk}
                                          name={q.sk}
                                          type="text"
                                          autoComplete="off"
                                          ref={register({
                                            validate: validatorFecha,
                                          })}
                                          defaultValue={q.value || ""}
                                          onChange={(e) => handleChange(e, i)}
                                          maxLength={q.metadata.maxLength}
                                        />
                                        <label
                                          className={q.value ? "active" : ""}
                                          htmlFor={q.sk}
                                        >
                                          {q.metadata.placeholder}
                                        </label> */}
                                        {/* <ErrorCustom
                                          errors={errors}
                                          name={q.sk}
                                        /> */}
                                        {errorDate && <div className="errorCustom">{errorDate}</div>}
                                      </div>
                                    )}
                                  </>
                                )
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                </div>
              ))}
              <div className="form-register__border"></div>
              <div className="form-register__buttom form-step">
                <Button
                  type="submit"
                  className={loadingClick ? "is-loading" : ""}
                  disabled={
                    (Object.keys(errors).length || enableButton) && !isValid && errorDate !== null
                      ? true
                      : false
                  }
                >
                  Continuar
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <ModalSteps />
      <Footer />
    </>
  );
};
